import { FC, PropsWithChildren } from 'react';
import { Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { Header } from './Header';
import { Footer } from './Footer';
import { Announcements } from './Announcements';
import { useSiteInfo } from '~/pages/_shared';
import { ActiveNavItemContextProvider } from './ActiveNavItemContext';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
   const router = useRouter();
   const { data: siteInfo } = useSiteInfo();

   const showHeader = !router.pathname.includes('embed');
   const showFooter = !router.pathname.includes('embed') && siteInfo?.['display-footer'];

   return (
      <Flex flexDirection="column" minHeight="100vh" bgColor="gray.50">
         <ActiveNavItemContextProvider>
            <Announcements />
            {showHeader && <Header />}
            {children}
            {showFooter && <Footer />}
         </ActiveNavItemContextProvider>
      </Flex>
   );
};
